const carouselItems = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20shot%20of%20a%20space%20epic%20with%20starships%20and%20nebula%2C%20warm%20golden%20and%20amber%20lighting%2C%20dramatic%20composition%2C%20epic%20scale%2C%20movie%20poster%20aesthetic%20with%20rich%20contrast%20and%20cinematic%20color%20grading&width=1400&height=800&seq=carousel-focus-01&orientation=landscape",
    title: "科幻电影月",
    subtitle: "探索宇宙 · 无限想象",
    desc: "精选全球顶级科幻大片，从经典到新作，带您遨游星际",
    tag: "主题专题",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20Korean%20drama%20romantic%20scene%20in%20autumn%20with%20golden%20leaves%20falling%2C%20warm%20nostalgic%20lighting%2C%20emotional%20and%20beautiful%20atmosphere%2C%20film-like%20quality%20with%20soft%20bokeh%20and%20rich%20warm%20tones&width=1400&height=800&seq=carousel-focus-02&orientation=landscape",
    title: "韩剧精选季",
    subtitle: "浪漫心动 · 高分必看",
    desc: "汇聚年度最受欢迎韩剧，催泪、甜宠、悬疑一次看够",
    tag: "主题专题",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20ancient%20Chinese%20palace%20scene%20with%20elaborate%20costumes%20and%20architecture%2C%20warm%20golden%20lantern%20lighting%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20rich%20historical%20aesthetic%20with%20deep%20warm%20shadows&width=1400&height=800&seq=carousel-focus-03&orientation=landscape",
    title: "古装仙侠剧场",
    subtitle: "侠义江湖 · 仙幻奇缘",
    desc: "从经典武侠到玄幻仙侠，精彩古装剧集一网打尽",
    tag: "主题专题",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20studio%20scene%20with%20colorful%20character%20illustrations%20and%20animation%20cells%2C%20warm%20creative%20workspace%20lighting%2C%20vibrant%20Japanese%20anime%20art%20style%2C%20energetic%20and%20inspiring%20atmosphere&width=1400&height=800&seq=carousel-focus-04&orientation=landscape",
    title: "动漫嘉年华",
    subtitle: "热血青春 · 奇幻冒险",
    desc: "全球热门番剧大合集，从经典到新番为您持续更新",
    tag: "主题专题",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20thriller%20suspense%20scene%20with%20a%20detective%20investigating%20in%20a%20dark%20rainy%20alley%2C%20warm%20streetlight%20glow%2C%20noir%20atmosphere%2C%20mysterious%20and%20tense%20mood%2C%20film%20noir%20aesthetic%20with%20rich%20contrast&width=1400&height=800&seq=carousel-focus-05&orientation=landscape",
    title: "悬疑推理专场",
    subtitle: "烧脑解谜 · 反转不断",
    desc: "挑战智力的悬疑佳作，每一部都让您欲罢不能",
    tag: "主题专题",
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              精选主题影视合集，按兴趣发现属于您的好片
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.slice(0, 3).map((item) => (
              <article
                key={item.id}
                className="group relative h-[280px] rounded-xl overflow-hidden border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={`爱看影院 — ${item.title}`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/80 text-background-950 text-xs font-medium mb-3">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-lg text-foreground-50 font-bold mb-1">{item.title}</h3>
                  <p className="text-xs text-primary-300 mb-1.5">{item.subtitle}</p>
                  <p className="text-xs text-foreground-300 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {carouselItems.slice(3, 5).map((item) => (
              <article
                key={item.id}
                className="group relative h-[220px] rounded-xl overflow-hidden border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={`爱看影院 — ${item.title}`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/80 text-background-950 text-xs font-medium mb-2">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-base text-foreground-50 font-bold mb-1">{item.title}</h3>
                  <p className="text-xs text-primary-300">{item.subtitle}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}